// extracted by mini-css-extract-plugin
export var actions = "_cw-g";
export var benefitCard = "_cw-b";
export var benefitIcon = "_cw-d";
export var benefitLabel = "_cw-f";
export var benefits = "_cw-a";
export var benefitsSection = "_cw-8";
export var bodyText = "_cw-7";
export var closeButton = "_cw-2";
export var content = "_cw-3";
export var eyebrow = "_cw-4";
export var heading = "_cw-5";
export var image = "_cw-i";
export var imagePanel = "_cw-h";
export var modal = "_cw-0";
export var offerCard = "_cw-c";
export var offerIcon = "_cw-e";
export var sectionLabel = "_cw-9";
export var shell = "_cw-1";
export var title = "_cw-6";